import styled from "styled-components";
import { colors } from "../../../../../../shared/styled/varibles";

export const ContextSC = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: 2.4rem 2rem 1.6rem 2.4rem;
    gap: 1rem;
    background: ${colors.bgMenu};
    border: 1px solid ${colors.bluishGray};
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.05);
    border-radius: 12px;
    height: 100%;
`;

export const PromptSC = styled.div`
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 1.8rem;
    line-height: 160%;
    letter-spacing: -0.01em;
    color: ${colors.textColor};
    overflow: auto;
`;

export const BottomSC = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    margin: 0 auto;
    align-self: stretch;
    flex-grow: 0;
    width: 100%;
`;

export const LeftSC = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    gap: 1rem;
`;

export const GenerateSC = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.2rem 1.4rem;
    gap: 1rem;
    background: ${colors.textColor};
    border-radius: 6rem;
`;

export const ButtonTextSC = styled.div`
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 2rem;
    line-height: 160%;
    letter-spacing: -0.01em;
    color: ${colors.white};
`;
